const findLastIndex = (array, predicate) => {
  for (let i = array.length - 1; i >= 0; i -= 1) {
    if (predicate(array[i])) {
      return i;
    }
  }
  return -1;
};
const getRange = (start, end) => {
  const length = end - start + 1;
  /*
  	Create an array of certain length and set the elements within it from
    start value to end value.
  */
  return Array.from({
    length
  }, (_, idx) => idx + start);
};

export { findLastIndex, getRange };
//# sourceMappingURL=index.js.map
